export const decodeBase64 = (val) => {
  return atob(val);
};

export const encodeBase64 = (val) => {
  return btoa(val);
};

export const UserDataDecode = (base64) => {
  let tmp = decodeBase64(base64).split(";");
  return {
    uId: tmp[0],
    session: tmp[1],
    token: tmp[2],
  };
};

export const RecordingDataDecode = (base64) => {
  let tmp = decodeBase64(base64).split(";");
  return {
    uId: tmp[0],
    session: tmp[1],
    token: tmp[2],
    agoraToken: tmp[3],
  };
};

export const SetLocalStorage = (name, value) => {
  localStorage.setItem(name, encodeBase64(value));
};

export const urlDataLocalBase64 = () => {
  let tmp = localStorage.getItem("bkdp_id");
  if (tmp == null) {
    return null;
  }
  return decodeBase64(tmp);
};

export const userDataLocalStorage = () => {
  let tmp = localStorage.getItem("bkdp_id");

  return UserDataDecode(decodeBase64(tmp));
};
